"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return SyncSource;
    }
});
const _User = /*#__PURE__*/ _interop_require_default(require("~/models/User"));
const _catchError = require("~/helpers/catchError");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let SyncSource = class SyncSource {
    getUser(ncMeta = _Noco.default.ncMeta) {
        return _User.default.get(this.fk_user_id, ncMeta);
    }
    static async get(context, syncSourceId, ncMeta = _Noco.default.ncMeta) {
        const syncSource = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.SYNC_SOURCE, syncSourceId);
        if (syncSource.details && typeof syncSource.details === 'string') {
            try {
                syncSource.details = JSON.parse(syncSource.details);
            } catch (unused) {}
        }
        return syncSource && new SyncSource(syncSource);
    }
    static async list(context, baseId, sourceId, ncMeta = _Noco.default.ncMeta) {
        const condition = sourceId ? {
            base_id: baseId,
            source_id: sourceId
        } : {
            base_id: baseId
        };
        const syncSources = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.SYNC_SOURCE, {
            condition,
            orderBy: {
                created_at: 'asc'
            }
        });
        for (const syncSource of syncSources){
            if (syncSource.details && typeof syncSource.details === 'string') {
                try {
                    syncSource.details = JSON.parse(syncSource.details);
                } catch (unused) {}
            }
        }
        return syncSources == null ? void 0 : syncSources.map((h)=>new SyncSource(h));
    }
    static async insert(context, syncSource, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(syncSource, [
            'id',
            'title',
            'type',
            'details',
            'base_id',
            'source_id',
            'fk_user_id'
        ]);
        if (insertObj.details && typeof insertObj.details === 'object') {
            insertObj.details = JSON.stringify(insertObj.details);
        }
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.SYNC_SOURCE, insertObj);
        return this.get(context, id, ncMeta);
    }
    static async update(context, syncSourceId, syncSource, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(syncSource, [
            'id',
            'title',
            'type',
            'details',
            'deleted',
            'order',
            'base_id',
            'source_id'
        ]);
        if (updateObj.details && typeof updateObj.details === 'object') {
            updateObj.details = JSON.stringify(updateObj.details);
        }
        // set meta
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.SYNC_SOURCE, updateObj, syncSourceId);
        return this.get(context, syncSourceId, ncMeta);
    }
    static async delete(context, syncSourceId, ncMeta = _Noco.default.ncMeta) {
        return await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.SYNC_SOURCE, syncSourceId);
    }
    static async deleteByUserId(userId, ncMeta = _Noco.default.ncMeta) {
        if (!userId) _catchError.NcError.badRequest('User Id is required');
        return await ncMeta.knex(_globals.MetaTable.SYNC_SOURCE).where({
            fk_user_id: userId
        }).del();
    }
    constructor(syncSource){
        Object.assign(this, syncSource);
    }
};
